import styled from 'styled-components';

import { StyledCenteredDiv } from '@styles/generalStyles';

interface ILoaderWrapperProps {
  height: number;
}

export const StyledWrapper = styled(StyledCenteredDiv)<ILoaderWrapperProps>`
  height: ${({ height }) => height}rem;
`;
